import { render, staticRenderFns } from "./CollectionActiveFilters.vue?vue&type=template&id=4987be4f&scoped=true&lang=pug&"
import script from "./CollectionActiveFilters.vue?vue&type=script&lang=js&"
export * from "./CollectionActiveFilters.vue?vue&type=script&lang=js&"
import style0 from "./CollectionActiveFilters.vue?vue&type=style&index=0&id=4987be4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4987be4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4987be4f')) {
      api.createRecord('4987be4f', component.options)
    } else {
      api.reload('4987be4f', component.options)
    }
    module.hot.accept("./CollectionActiveFilters.vue?vue&type=template&id=4987be4f&scoped=true&lang=pug&", function () {
      api.rerender('4987be4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionActiveFilters.vue"
export default component.exports